/**
 * Commodity Custom Reports Page (KAN-265)
 * Thin wrapper around the shared CustomReports page with assetClass='COMMODITY'.
 */

import React from 'react';
import CustomReports from '../CustomReports';

const CommodityCustomReports: React.FC = () => {
  return <CustomReports assetClass="COMMODITY" />;
};

export default CommodityCustomReports;
